export const getImageSrc = (imageUrl: string | null | undefined, fallbackSrc: string): string => {
  const normalizedUrl = imageUrl?.trim();

  if (!normalizedUrl) {
    return fallbackSrc;
  }

  const lowered = normalizedUrl.toLowerCase();
  if (lowered === 'null' || lowered === 'undefined') {
    return fallbackSrc;
  }

  return normalizedUrl;
};
